import React from "react";
import { EmptyState } from "./common";

const LEVEL_ORDER = { chief: 0, "assistant chief": 1, captain: 2, lieutenant: 3 };

function rank(member) {
  if (typeof member.level === "number") return member.level;
  const t = String(member.title || "").toLowerCase();
  for (const key of Object.keys(LEVEL_ORDER)) if (t.includes(key)) return LEVEL_ORDER[key];
  return 5;
}

// Officers / org chart. Roster lives in the widget config (edited in the designer).
const LeadershipWidget = ({ config = {}, board }) => {
  const roster = (config.leadership || [])
    .slice()
    .sort((a, b) => (a.order ?? rank(a)) - (b.order ?? rank(b)) || rank(a) - rank(b));
  const accent = board?.theme?.accent || "#c0392b";

  if (roster.length === 0) {
    return (
      <div className="sb-card sb-leadership">
        <EmptyState icon="★" label="Add leadership in the Board Designer." />
      </div>
    );
  }

  return (
    <div className="sb-card sb-leadership">
      <div className="sb-leadership-title" style={{ color: accent }}>
        Our Chiefs &amp; Officers
      </div>
      <div className="sb-leadership-grid">
        {roster.map((m, i) => (
          <div className="sb-leader" key={m.id || i}>
            <div className="sb-leader-photo">
              {m.image ? (
                <img src={m.image} alt={m.title || m.name || "Officer"} />
              ) : (
                <div className="sb-leader-placeholder">{(m.name || m.title || "?").charAt(0)}</div>
              )}
            </div>
            <div className="sb-leader-title">{m.title}</div>
            {m.name && <div className="sb-leader-name">{m.name}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LeadershipWidget;
